import * as React from 'react';
import { Route, Link, withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import ResourceList from './Resources/List';
import { ForumFeed } from './Forum/ForumFeed';
import { MembersList } from './Member/List';
import { ForumTag } from './ForumTag';
import { AddItem } from './Member/AddItem';
import {NotificationList} from './Notifications/List';
import { Search } from './Search';
import { Modal } from '../Controls/Modal';
import { Spinner } from '../Controls/Spinner';
import { ForumList } from './Forum/List';
import { SideBar } from './SideBar';
import * as Config from '../../configuration/consts';
import { ActiveMemberList } from './Member/ActiveList';

var moment = require('moment');

const queryString = require('query-string');
@withRouter
export class DiscussionBoard extends React.Component<any, any> {

    constructor(props) {
        super(props);

        // Default to first topic
        let showMessage:boolean = (props.forum && props.forum.defaultMessage != undefined);
        this.state = { showMessage: showMessage, mobileShowSearch: undefined, mobileShowTags: undefined  }
        
        this.onShowActiveTab = this.onShowActiveTab.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this.onSwitchForum = this.onSwitchForum.bind(this);
        this.onMessageClose = this.onMessageClose.bind(this);
        this.onMobileShowTags = this.onMobileShowTags.bind(this);
        this.onMobileShowSearch = this.onMobileShowSearch.bind(this);
        this.onNotificationsClicked = this.onNotificationsClicked.bind(this);
    }

    onSwitchForum() {
        this.props.switchForum();
    }

    onLogout() {
        this.props.logout(this.props.currentUser.email);
    }
    onMobileShowTags(tab) {
        this.setState({ mobileShowTags: !this.state.mobileShowTags });
    }

    onMobileShowSearch(tab) {
        this.setState({ mobileShowSearch: !this.state.mobileShowSearch });
    }
    
    onShowActiveTab(tab) {
        let filter = tab == Config.SHOW_FORUM ? Config.FILTER_DEFAULT : undefined;
        this.props.changeActiveTab(tab);
        if(tab === Config.SHOW_NOTIFICATIONS){
            this.props.refreshForumData(this.props.forum.id, false);
        }
        this.setState({ filter: filter });
    }

    tabCss(tab) {
        return this.props.activeTab == tab ? "nav-link active" : "nav-link";
    }

    onNotificationsClicked(){
        this.onShowActiveTab(Config.SHOW_NOTIFICATIONS);
    }
    
    componentDidUpdate(prevProps, prevState) {
        if(!prevProps.forum && this.props.forum){
            let showMessage:boolean = (this.props.forum && this.props.forum.defaultMessage != undefined);
            this.setState({showMessage: showMessage});
        } 
    }
    
    onMessageClose() {
        this.setState({ showMessage: false });
    }

    render() {
        const { userRole, forum, forums, currentUser, forumLoading,
                login,
                saveUser, editUser, 
                saveResource, editResource, 
                savePost, deletePost, addPostTag, saveTagRequest, activeTag,
                searchPosts, searchResources, searchUsers, searchRequest, ...props } = this.props;
        const { tags, filter } = this.state;
        let content = undefined;
        let isAdmin = userRole == Config.ROLE_ADMIN;
        let loadSpinner = false;

        
        let notifications = forum ? 
        <li className="nav-item" onClick={this.onShowActiveTab.bind(this, Config.SHOW_NOTIFICATIONS)}>
            <a className={this.tabCss(Config.SHOW_NOTIFICATIONS)} href="#">
                NOTIFICATIONS
                {forum && forum.notifications && forum.notifications.filter(n => !n.markAsRead).length > 0 ? 
                    <small>
                    <span className="fa-stack" style={{marginTop: "-5px"}}>
                        <i className="fa fa-circle fa-stack-2x text-red"></i>
                        <strong className="fa-stack-1x text-white">{forum.notifications.filter(n => !n.markAsRead).length}</strong>
                    </span></small> : undefined }
            </a>
        </li> : undefined;

        let usersTab = isAdmin ?
                        <li className="nav-item" onClick={this.onShowActiveTab.bind(this, Config.SHOW_MEMBERS)}>
                            <a  className={this.tabCss(Config.SHOW_MEMBERS)} href="#">Members</a>
                        </li> :
                        <li className="nav-item" onClick={this.onShowActiveTab.bind(this, Config.SHOW_PROFILE)}>
                            <a  className={this.tabCss(Config.SHOW_PROFILE)} href="#">Profile</a>
                        </li>;


        let type = this.props.activeTab == Config.SHOW_FORUM ? "POST" : this.props.activeTab == Config.SHOW_RESOURCES ? "RESOURCE" : undefined;
        let activeFilter = forum && forum.activeTags ? forum.activeTags.find(i => i.type === type) : undefined;

        switch(this.props.activeTab){
            case Config.SHOW_FORUM:
                content = forum ? <ForumFeed userRole={userRole} activeFilter={activeFilter} {...this.props} /> : undefined;
            break;
            case Config.SHOW_RESOURCES:
                content = forum ? <ResourceList userRole={userRole}  activeFilter={activeFilter} {...this.props} /> : undefined;
            break;
            case Config.SHOW_MEMBERS:
                content = forum ? <MembersList userRole={userRole} {...this.props} /> : undefined;
            break;
            case Config.SHOW_PROFILE:
                content = <div className="col-12 col-md-9"><AddItem userRole={userRole} {...this.props} user={currentUser}/></div>;
            break;
            case Config.SHOW_BOARDS:
                content = <ForumList {...this.props} />;
            break;
            case Config.SHOW_NOTIFICATIONS:
                content = <NotificationList {...this.props} />;
            break;
        }
        
        if(forum){
            //let isMessageOpen: boolean = this.state.showMessage && props.forum && !props.forumLoading ? this.state.showMessage : (props.forum && props.forum.loaded && props.forum.defaultMessage != undefined);
            let defaultMessage = forum && forum.loaded && forum.defaultMessage && this.state.showMessage ? 
                <Modal isOpen={true}
                    onRequestClose={this.onMessageClose}
                    label="Modal"
                    height="200px">
                    
                    <button type="button" className="close pt-2 pr-2" data-dismiss="alert" aria-label="Close" 
                        onClick={this.onMessageClose}><span aria-hidden="true">&times;</span></button>
                    <div className="mx-5 my-5">
                        <div className="row" style={{height: "100%"}}>
                            <div className="text-middle col col-4 ">
                                <img className="modal-warning-image" src={require("../../assets/img/CRE_icon_warning-exclamation.svg")} />
                            </div>
                            <div className="text-middle col col-8 ">
                                <strong dangerouslySetInnerHTML={{__html: forum.defaultMessage.toUpperCase()}}></strong>
                            </div>
                        </div>
                    </div>
                </Modal> : undefined;
        
            let resourcesTab  =   <li className="nav-item">
                                <a onClick={this.onShowActiveTab.bind(this, Config.SHOW_RESOURCES)} className={this.tabCss(Config.SHOW_RESOURCES)} href="#">Resources</a>
                            </li>;
            let discussionTab  =   <li className="nav-item">
                                    <a onClick={this.onShowActiveTab.bind(this, Config.SHOW_FORUM)} className={this.tabCss(Config.SHOW_FORUM)} href="#">Discussion</a>
                                </li>;
        
            content = <div>
                            {defaultMessage}
                            <div className="row lightgrey-bg mb-4">
                                <ul className="discussion-board nav nav-tabs lightgrey-bg col-12">
                                    { forum && forum.isResourceTabDefault ? resourcesTab : discussionTab }
                                    { forum && forum.isResourceTabDefault ? discussionTab : resourcesTab }
                                    {usersTab}
                                    {notifications}
                                </ul>
                            </div>
                            <div className="row fixed-scrolling-side">
                                <SideBar activeTab={this.props.activeTab} onNotificationsClicked={this.onNotificationsClicked} {...this.props} />
                                
                                {content}
                                <div className="col-12 col-md-2 px-0">
                                {
                                    forum && forum.members && forum.members.length > 0 ? <ActiveMemberList members={forum.members} theme={forum.themeColour} />
                                    : undefined
                                }
                                </div>
                            </div>
                            <Spinner isOpen={loadSpinner} />
                    </div>;
        } else {
            loadSpinner = !forumLoading ? false : true;
            content = <div>
                        <div className="row lightgrey-bg mb-4">
                            <ul className="discussion-board nav nav-tabs lightgrey-bg col-12">
                                <li className="nav-item">
                                    <a onClick={this.onShowActiveTab.bind(this, Config.SHOW_BOARDS)} className={this.tabCss(Config.SHOW_BOARDS)} href="#">My Boards</a>
                                </li>
                            </ul>
                        </div>
                        <div className="row fixed-scrolling-side" >
                            <SideBar activeTab={this.props.activeTab} {...this.props} />
                            {content}
                            <div className="col-12 col-md-2 px-0">
                            {
                                forum && forum.members && forum.members.length > 0 ? <ActiveMemberList members={forum.members} theme={forum.themeColour} />
                                : undefined
                            }
                            </div>
                        </div>
                        <Spinner isOpen={loadSpinner}  />
                    </div>;
        }
 
        return (content)
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/DiscussionBoard.tsx